/**
 * Значения из node-deposits-panel (`NetworkCostGroup.operationType`, `state`, `payer`).
 * @see operation-costs.ts, withdrawal-cost-quote.ts, network-cost-service.ts
 */
export const NETWORK_COST_OPERATION_TYPES = [
  'WITHDRAWAL',
  'SWAP',
  'REFUND',
  'DEPOSIT_COLLECTION',
  'INTERNAL_TRANSFER',
] as const;

export type NetworkCostOperationType = (typeof NETWORK_COST_OPERATION_TYPES)[number];

/** Состояния группы сетевых расходов в БД (строка `state`). */
export const NETWORK_COST_GROUP_STATES = [
  'PREPARED',
  'CHARGED',
  'SETTLING',
  'SETTLED',
  'MANUAL_REVIEW',
  'CANCELLED',
] as const;

export type NetworkCostGroupState = (typeof NETWORK_COST_GROUP_STATES)[number];

export const NETWORK_COST_PAYERS = ['MERCHANT', 'PAYGATEX'] as const;

export type NetworkCostPayer = (typeof NETWORK_COST_PAYERS)[number];
